module.exports = __webpack_public_path__ + "img/interaction-fanli.8e288763.png";